function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.85 5.849a6.576 6.576 0 019.223.08 6.588 6.588 0 01.08 9.23l-.013.014-3.29 3.293a6.578 6.578 0 01-7.807 1.123 6.58 6.58 0 01-2.114-1.834 1.096 1.096 0 111.756-1.315 4.388 4.388 0 005.045 1.484 4.387 4.387 0 001.57-1.01l3.282-3.286a4.393 4.393 0 00-3.123-7.433 4.384 4.384 0 00-3.08 1.227L16.5 9.293a1.096 1.096 0 11-1.546-1.557l1.886-1.876.011-.011zm-5.347 6.17a6.573 6.573 0 017.568 2.226 1.096 1.096 0 11-1.756 1.315 4.388 4.388 0 00-5.045-1.484c-.59.22-1.125.565-1.57 1.01l-3.282 3.286a4.392 4.392 0 003.123 7.433 4.384 4.384 0 003.079-1.226l1.868-1.87a1.096 1.096 0 111.55 1.552l-1.875 1.877-.013.013a6.576 6.576 0 01-9.223-.08 6.588 6.588 0 01-.08-9.23l.013-.015 3.29-3.292a6.578 6.578 0 012.353-1.514z",
    fill: props.color
  }));
}

export default SvgIconLink;